import { SemanticCOLORS } from "semantic-ui-react";
import { DetailedOrder } from "../../types/models/Reporting";
import { ORDERS_STATUSES } from "../../utils/constants";

const currencyFormatter = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
});

const numberFormatter = new Intl.NumberFormat("es-MX");

export const formatCurrency = (value?: number | null) =>
    currencyFormatter.format(Number(value ?? 0));

export const formatNumber = (value?: number | null) =>
    numberFormatter.format(Number(value ?? 0));

export const formatPercent = (value?: number | null) =>
    `${Number(value ?? 0).toLocaleString("es-MX", { maximumFractionDigits: 2 })}%`;

export const formatReportDate = (value?: string | null, withTime = false) => {
    if (!value) return "—";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return value;
    return new Intl.DateTimeFormat("es-MX", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
    }).format(parsed);
};

export const formatMonth = (value?: string | null) => {
    if (!value) return "—";
    const parsed = new Date(`${value.slice(0, 10)}T12:00:00`);
    if (Number.isNaN(parsed.getTime())) return value;
    return new Intl.DateTimeFormat("es-MX", {
        month: "short",
        year: "numeric",
    }).format(parsed);
};

export const riskColor = (risk?: string): SemanticCOLORS => {
    switch (risk) {
        case "CRITICAL": return "red";
        case "HIGH": return "orange";
        case "MEDIUM": return "yellow";
        case "LOW": return "green";
        default: return "grey";
    }
};

export const riskLabel = (risk?: string) => {
    switch (risk) {
        case "CRITICAL": return "Crítico";
        case "HIGH": return "Alto";
        case "MEDIUM": return "Medio";
        case "LOW": return "Bajo";
        default: return risk || "Sin nivel";
    }
};

export const orderStatusColor = (status?: string): SemanticCOLORS =>
    status && ORDERS_STATUSES[status]?.color
        ? ORDERS_STATUSES[status].color
        : "grey";

export const orderStatusLabel = (status?: string, label?: string) =>
    label || (status ? ORDERS_STATUSES[status]?.name || status : "Sin estado");

export const formatReportAddress = (address?: DetailedOrder["address"]) => {
    if (!address) return "Sin dirección";
    const street = [address.street, address.exteriorNumber, address.interiorNumber]
        .filter(Boolean)
        .join(" ");
    return [
        street,
        address.neighborhood,
        address.municipality || address.city,
        address.state,
        address.postalCode ? `C.P. ${address.postalCode}` : undefined,
    ].filter(Boolean).join(", ");
};

export const paymentTypeLabel = (type: string) => {
    const labels: Record<string, string> = {
        ADVANCE: "Anticipo",
        INSTALLMENT: "Abono",
        PARTIAL_SETTLEMENT: "Liquidación parcial",
        FULL_SETTLEMENT: "Liquidación",
    };
    return labels[type] || type;
};
